module.exports = {"445203001":"曲溪街道","445203002":"磐东街道","445203102":"云路镇","445203103":"玉窖镇","445203104":"锡场镇","445203105":"新亨镇","445203106":"玉湖镇","445203107":"埔田镇","445203108":"霖磐镇","445203109":"月城镇","445203110":"白塔镇","445203111":"龙尾镇","445203112":"桂岭镇","445203401":"东径茶场","445203402":"坪上农场","445203403":"揭阳高新技术产业开发区","445203404":"卅岭农场","445203405":"蓝城区工业园区管理处","445203406":"珠海（揭阳）产业转移工业园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/445203.json
// module id = 2060
// module chunks = 0